export default __webpack_public_path__ + "static/media/NoResults-mobile.932e5cd6.svg";